window.theme = window.theme || {};

theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }
}

theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes(',')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();


function handleSizeLogic(target) {
  if (!target || !target.dataset.option) return;
  if (!target.dataset.option.startsWith('size-')) return;

  const optionName = target.dataset.option;
  const addon2 = document.querySelector('[js-addon-2]');
  const addon3 = document.querySelector('[js-addon-3]');
  if (!addon2 || !addon3) return;
  const disableAddon = (el) => {
    el.checked = false;
    el.setAttribute('disabled', 'true');
  };
  const enableAddon = (el) => {
    el.checked = true;
    el.removeAttribute('disabled');
  };
  if (optionName === 'size-1') {
    disableAddon(addon2);
    disableAddon(addon3);
  }
  if (optionName === 'size-2') {
    enableAddon(addon2);
    disableAddon(addon3);
  }
  if (optionName === 'size-3') {
    enableAddon(addon2);
    enableAddon(addon3);
  }
}

document.addEventListener('change', function (e) {
  handleSizeLogic(e.target);
});
document.addEventListener('DOMContentLoaded', function () {
  const checkedSize = document.querySelector('[data-option^="size-"]:checked');
  if (checkedSize) {
    handleSizeLogic(checkedSize);
  }
});

function handleAutoGiftRemoval() {
  const giftRows = document.querySelectorAll('.cart-item[data-reset-type]');
  if (!giftRows.length) return;

  const hasValidReset = cartHasValidReset(); 

  giftRows.forEach((row) => {
    const resetType = row.dataset.resetType?.trim();
    const hasRemove2 = row.classList.contains('remove_gift_2');
    const hasRemove3 = row.classList.contains('remove_gift_3');
    const variantId = row.dataset.variantId;

    if (resetType === '14' && hasValidReset) return;

    if (!hasRemove2 && !hasRemove3) return;
    if (hasRemove2 && !hasRemove3) return;

    if (!hasRemove2 && hasRemove3) {
      if (variantId === '51956117373250') return;
      autoRemove(row);
      return;
    }

    if (hasRemove2 && hasRemove3) {
      autoRemove(row);
    }
  });
}
function cartHasValidReset() {
  return document.querySelector(
    '.cart-item[data-reset-type="28"], .cart-item[data-reset-type="56"]'
  );
}

function autoRemove(row) {
  const btn = row.querySelector('cart-remove-button button');
  if (!btn) return;
  btn.click();
}



class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.qty = 1;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('[js-qty-input-btn]');
    this.input = this.querySelector('[js-qty-input]');
    this.qtyBadge = this.querySelector('[js-qty-badge]');
    this.headerBadge = this.querySelector('[js-header-badge]'); 

    this.init();
  }

  init() {
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {

        this.buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        this.qty = parseInt(btn.dataset.qty) || 1;

        if (this.input) {
          this.input.value = this.qty;
        }

        if (this.qtyBadge) {
          this.qty === 3
            ? this.qtyBadge.classList.add('is-active')
            : this.qtyBadge.classList.remove('is-active');
        }
        this.updateHeaderBadge();

        document.dispatchEvent(new CustomEvent('qty:change', {
          detail: { qty: this.qty }
        }));
      });
    });
  }
  updateHeaderBadge() {
    if (!this.headerBadge) return;

    const span = this.headerBadge.querySelector('span');
    if (!span) return;

    const p1 = this.headerBadge.dataset.percentageSingle;
    const p3 = this.headerBadge.dataset.percentageBulk;

    const value = this.qty === 3 ? p3 : p1;

    span.textContent = value;
  }
}

customElements.define('quantity-selector', QuantitySelector);


class ProductSubscription extends HTMLElement {
  constructor() {
    super();

    this.qty = 1;

    this.base = {
      oneTimePrice: 0,
      oneTimeCompare: 0
    };
  }

  connectedCallback() {
    this.select = this.querySelector('[js-product-subscription]');
    this.selectOptions = this.querySelectorAll('[js-subscription]');
    this.giftProduct = this.querySelector('[js-gift-product]');
    this.headerPercentage = this.querySelector('[js-header-percentage]');
    this.bottomWraps = this.querySelectorAll('.product_subcriptions__bottom-sub-wrap');

    this.priceEl = this.querySelector('[js-subscription-original-price]');
    this.compareEl = this.querySelector('[js-subscription-compare-price]');

    this.oneOriginalEl = this.querySelector('[js-one-time-original-price]');
    this.oneCompareEl = this.querySelector('[js-one-time-compare-price]');

    this.sellingTexts = this.querySelectorAll('[js-selling-plain-text]');

    this.btnPrice = document.querySelector('button[type="submit"] .product_price');

    this.initBasePrices();
    this.initEvents();
    this.setInitialSelectedType();

    document.addEventListener('qty:change', (e) => {
      this.qty = e.detail.qty || 1;

      this.handleQtyUI();
      this.handleSelectUI();
      this.updatePrices();
      this.updateBtnPrice(); 
      this.updateHeaderPercentage();
      this.updateBottomWrap();
      this.updateUsageText();
      this.updateSubUsage();
    });
  }

  setInitialSelectedType() {
    const activeOption = [...this.selectOptions].find(opt =>
      opt.classList.contains('is-checked')
    );

    if (!activeOption) return;

    const input = activeOption.querySelector('input');
    const type = input?.getAttribute('is');

    this.selectedType = type;
  }
  // -----------------------------
  // BASE PRICES (ONE-TIME ONLY)
  // -----------------------------
  initBasePrices() {
    this.base.oneTimePrice = Number(this.oneOriginalEl?.dataset.price || 0);
    this.base.oneTimeBulkPrice = Number(this.oneOriginalEl?.dataset.bulkPrice || 0);
    this.base.oneTimeCompare = Number(this.oneCompareEl?.dataset.price || 0);
  }

  parseMoney(val) {
    if (!val) return 0;
    return Number(val.replace(/[^0-9.-]+/g, '')) || 0;
  }

  // -----------------------------
  // PLAN SELECT UI (CART ONLY)
  // -----------------------------
  handleSelectUI() {
    if (!this.select) return;

    // qty 3 → second plan (12-week)
    this.select.selectedIndex = this.qty === 3 ? 1 : 0;
  }

  // -----------------------------
  // TEXT SWITCH
  // -----------------------------
  handleQtyUI() {
    if (!this.sellingTexts || this.sellingTexts.length < 2) return;

    const isBulk = this.qty === 3;

    this.sellingTexts[0].classList.toggle('hidden', isBulk);
    this.sellingTexts[1].classList.toggle('hidden', !isBulk);
  }
  updateHeaderPercentage() {
    if (!this.headerPercentage) return;

    const span = this.headerPercentage.querySelector('span');
    if (!span) return;

    const p1 = this.headerPercentage.dataset.percentageSingle;
    const p3 = this.headerPercentage.dataset.percentageBulk;

    const value = this.qty === 3 ? p3 : p1;
    span.textContent = value;
  }
  updateBottomWrap() {

    if (!this.bottomWraps) return;

    const isBulk = this.qty === 3;

    this.bottomWraps.forEach((el, index) => {
      const isThird = index === 2;

      if (isThird) {
        if (isBulk) {
          el.classList.remove('hidden');   
        } else {
          el.classList.add('hidden'); 
        }
      }
    });
  }
  updateUsageText() {
    const el = this.querySelector('[js-one-time-daily-usage]');
    if (!el) return;

    const span = el.querySelector('span');
    if (!span) return;

    const single = Number(el.dataset.singleUsage);
    const bulk = Number(el.dataset.bulkUsage);

    const value = this.qty === 3 ? bulk : single;

    span.textContent = theme.Currency.formatMoney(
      value,
      theme.settings.moneyFormat
    ); // ✅ FIX
  }
  updateSubUsage() {
    const el = this.querySelector('[js-sub-daily-usage]');
    if (!el) return;

    const span = el.querySelector('span');
    if (!span) return;

    const selectedOption = this.select?.options[this.select.selectedIndex];
    if (!selectedOption) return;

    const price = Number(selectedOption.dataset.price) || 0;

    const final = price / 28;

    span.textContent = theme.Currency.formatMoney(
      final,
      theme.settings.moneyFormat
    );
  }

  // -----------------------------
  // EVENTS
  // -----------------------------
  initEvents() {
    this.selectOptions.forEach(option => {
      option.addEventListener('click', () => {

        this.selectOptions.forEach(opt => opt.classList.remove('is-checked'));
        option.classList.add('is-checked');

        const input = option.querySelector('input');
        const type = input?.getAttribute('is');

        this.selectedType = type; // ✅ SAVE STATE

        if (type === 'subscription') {
          this.select?.removeAttribute('disabled');
          this.giftProduct?.removeAttribute('disabled');
        } else {
          this.select?.setAttribute('disabled', 'disabled');
          this.giftProduct?.setAttribute('disabled', 'disabled');
        }

        this.updateBtnPrice();
      });
    });
  }

  // -----------------------------
  // MAIN PRICE LOGIC (IMPORTANT FIX)
  // -----------------------------
  updatePrices() {

    const qty = this.qty;

    const selectedOption = this.select?.options[this.select.selectedIndex];
    if (!selectedOption) return;

    const subBasePrice = Number(selectedOption.dataset.price) || 0;
    const subBaseCompare = Number(selectedOption.dataset.compareAtPrice) || 0;

    const isBulk = qty === 3;

    const oneBasePrice = isBulk
      ? this.base.oneTimeBulkPrice
      : this.base.oneTimePrice;

    const oneBaseCompare = this.base.oneTimeCompare;

    this.set('[js-one-time-original-price]', oneBasePrice);
    this.set('[js-one-time-compare-price]', oneBaseCompare);

    this.updateMain(subBasePrice, subBaseCompare);
  }
  updateMain(price, compare) {

    if (this.priceEl) {
      this.priceEl.textContent = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
    }

    if (this.compareEl) {
      this.compareEl.textContent = theme.Currency.formatMoney(compare, theme.settings.moneyFormat);
    }
  }

  // -----------------------------
  // SET DOM PRICE
  // -----------------------------
  set(selector, value) {
    const el = this.querySelector(selector);
    if (!el) return;

    el.textContent = theme.Currency.formatMoney(
      value,
      theme.settings.moneyFormat
    );
  }

  // -----------------------------
  // MAIN UI
  // -----------------------------
 
  updateBtnPrice() {

    const qty = this.qty;

    const selectedOption = this.select?.options[this.select.selectedIndex];
    if (!selectedOption) return;
    const isOneTime = this.selectedType === 'one-time-purchase';

    const subBasePrice = Number(selectedOption.dataset.price) || 0;

    const isBulk = qty === 3;

    const oneBasePrice = isBulk
      ? this.base.oneTimeBulkPrice
      : this.base.oneTimePrice;

    const basePrice = isOneTime ? oneBasePrice : subBasePrice;

    const finalPrice = basePrice * qty;

    if (this.btnPrice) {
      this.btnPrice.textContent = theme.Currency.formatMoney(
        finalPrice,
        theme.settings.moneyFormat
      );
    }
  }
}

customElements.define('product-subscription', ProductSubscription);